import script from "./RoutingStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutingStrip.vue?vue&type=script&setup=true&lang=js"

import "./RoutingStrip.vue?vue&type=style&index=0&id=b436e320&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b436e320"]])

export default __exports__